<template>
  <md-card-content>
    <!-- 決済方法 -->
    <div class="md-layout md-gutter">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>決済方法</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field>
          <label>{{ getBillMethodName(form.bill_method) }}</label>
        </md-field>
      </div>
    </div>


    <!-- カード情報 -->
    <div class="md-layout md-gutter" v-if="form.bill_method === billingMethodCreditCard">
      <div class="md-layout md-layout-item md-alignment-center-left md-size-20 md-small-size-100">
        <label>カード情報</label>
      </div>
      <div class="md-layout-item md-size-30 md-small-size-100">
        <md-field>
          <label>{{ form.cardNumber }}</label>
        </md-field>
      </div>
    </div>
  </md-card-content>
</template>

<script>
import Common      from "../../modules/common";
import CommonMixin from "../../mixins/commonMixin";

export default {
  name  : 'ContractPreviewPayment',
  mixins: [CommonMixin],
  props : ['form'],
  data  : () => ({
    billingMethodCreditCard: Common.billingMethodCreditCard,
  }),
}
</script>

<style lang="scss" scoped>
</style>
